import I18nProvider from "../../../../provider/I18nProvider";
import ContextPadProvider from "./ContextPadProvider";
import PaletteProvider from "./PaletteProvider";
import ReplaceMenuProvider from "./ReplaceMenuProvider";
import Connect from "./Connect";
import GlobalConnect from "./GlobalConnect";

const CustomModules = {
    translate: ['value', (key) => {
        return I18nProvider.translate(`bpmn.${key}`);
    }],
    replaceMenuProvider: ['type', ReplaceMenuProvider],
    contextPadProvider: ['type', ContextPadProvider],
    paletteProvider: ['type', PaletteProvider],
    connect: ['type', Connect],
    globalConnect: ['type', GlobalConnect]
};

export default CustomModules;